import { useCallback, useMemo, useRef, useState } from "react";
import { toggleSelectedAll, toggleSelectedId } from "./helper";

// Giữ danh sách id hóa đơn đã tích. Vì phân trang là phía server nên dòng của
// trang trước không còn trong items — phải nhớ luôn cả object dòng để lúc lập
// bảng kê vẫn lấy đủ hóa đơn đã chọn ở mọi trang.
export const useStatementSelection = () => {
  const [selectedIds, setSelectedIds] = useState([]);
  const rowsById = useRef(new Map());

  const remember = rows => {
    rows.forEach(row => {
      if (row && row.id !== undefined) {
        rowsById.current.set(row.id, row);
      }
    });
  };

  const select = useCallback((row, isSelect) => {
    remember([row]);
    setSelectedIds(prev => toggleSelectedId(prev, row.id, isSelect));
  }, []);

  const selectAll = useCallback((isSelect, rows) => {
    remember(rows || []);
    setSelectedIds(prev => toggleSelectedAll(prev, rows, isSelect));
  }, []);

  const clear = useCallback(() => {
    rowsById.current.clear();
    setSelectedIds([]);
  }, []);

  const selectedRows = useMemo(
    () => selectedIds.map(id => rowsById.current.get(id)).filter(Boolean),
    [selectedIds]
  );

  return { selectedIds, selectedRows, select, selectAll, clear };
};
